import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useAuth } from './AuthContext';
import { sessionStatuses } from './utils/Consts';

/** Dialog to notify the user that their session has expired */
function SessionExpiredDialog({ t }) {
  const { sessionState } = useAuth();
  const [timeoutIgnored, setTimeoutIgnored] = useState(false);
  const open = sessionState === sessionStatuses.EXPIRED && !timeoutIgnored;

  const handleClose = () => {
    setTimeoutIgnored(true);
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='timeout-dialog-title'
    >
      <DialogTitle id='timeout-dialog-title'>{t('sessionExpiredDialog.header')}</DialogTitle>
      <DialogContent>
        {t('sessionExpiredDialog.sessionExpired')}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant='text' color='primary'>
          {t('sessionExpiredDialog.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SessionExpiredDialog.propTypes = {
  /** react-i18next function for translation */
  t: PropTypes.func.isRequired,
};

export default withTranslation('translations')(SessionExpiredDialog);
